import { doApi } from './apiClient';
import type { Belt, AssignBeltPayload, AssignBeltResponse } from '../types';

export const apiListCinture = async (): Promise<Belt[]> => {
  return doApi<Belt[]>('api/belts/list', 'GET');
};

export const apiListCintureForAlbo = async (): Promise<Belt[]> => {
  return doApi<Belt[]>('api/belts/albo/list', 'GET');
};

export const apiGetBeltById = async (id: number): Promise<Belt> => {
  return doApi<Belt>(`api/belts/get/${id}`, 'GET');
};

export const apiGetBeltByIdTag = async (id: number): Promise<Belt> => {
  return doApi<Belt>(`api/belts/get/tag/${id}`, 'GET');
};

export const apiAssignBelt = async (data: AssignBeltPayload): Promise<AssignBeltResponse> => {
  return doApi<AssignBeltResponse>('api/belts/assign/', 'POST', data);
};

// V2 APIs
export const apiListBeltsV2 = async (): Promise<Belt[]> => {
  return doApi<Belt[]>('api/belts/v2/all', 'GET');
};

export const apiCreateBeltV2 = async (formData: FormData): Promise<Belt> => {
  return doApi<Belt>('api/belts/v2/create', 'POST', formData, true);
};

export const apiUpdateBeltV2 = async (id: number, formData: FormData): Promise<Belt> => {
  return doApi<Belt>(`api/belts/v2/edit/${id}`, 'PUT', formData, true);
};

// Hall of Fame Management APIs
export interface AddChampionPayload {
  belt_id: number;
  is_vacant: boolean;
  date: string;
  show_name: string;
  wrestler_ids: number[];
}

export interface HallOfFameResponse {
  status: 'error' | 'success';
  message?: string;
}

export const apiAddChampionToHallOfFame = async (data: AddChampionPayload): Promise<HallOfFameResponse> => {
  return doApi<HallOfFameResponse>('api/belts/v2/honor/add', 'POST', data);
};

export const apiRemoveChampionFromHallOfFame = async (id: number, beltId: number): Promise<HallOfFameResponse> => {
  return doApi<HallOfFameResponse>(`api/belts/v2/honor/${id}`, 'DELETE', { belt_id: beltId });
};

// Champions
export interface CurrentChampionWrestler {
  id: number;
  name: string;
  avatar_path: string;
}

export interface CurrentBeltChampion {
  belt_id: number;
  name: string;
  img_path: string;
  is_team: boolean;
  importance: number;
  is_vacant: boolean;
  champions: CurrentChampionWrestler[];
  date_win: string | null;
  show_name: string | null;
}

export const apiGetChampions = async (): Promise<{ data: CurrentBeltChampion[] }> =>
  doApi<{ data: CurrentBeltChampion[] }>('api/belts/v2/champions', 'GET');
